import { PagePending } from "@/components/ui/PagePending";
import { Sidebar } from "@/pages/admin/reports/Sidebar";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/reports/$countryCode")({
  pendingComponent: PagePending,
  beforeLoad: async () => {
    return {
      sidebar: <Sidebar />,
    };
  },
});
